
import {Component, Prop, Vue} from "vue-property-decorator";
import InstrumentContextCache from "@/models/instrument.context.cache";

@Component
export default class InstrumentStateIcon extends Vue {
  @Prop() instrument!: InstrumentContextCache;

  tooltipDefault = "Instrument bearbeiten";
  tooltipNew = "Instrument anlegen";
  tooltipComplete = this.tooltipDefault;
  tooltipIncomplete = this.tooltipDefault;

  get isNew() {
    return this.instrument?.isNew ?? false
  }

  get hasMissingData() {
    return this.instrument?.hasMissingData() ?? false
  }

  get isComplete() {
    return this.instrument?.isComplete() ?? false
  }

  get isEditable() {
    return this.instrument?.isEditable ?? false;
  }

  get notEditableReason() {
    return this.instrument.notEditableReason ?? "";
  }
}
